// extracted by mini-css-extract-plugin
export default {"trainingStatus":"trainig-status_trainingStatus__SLFfb","incorrectMessage":"trainig-status_incorrectMessage__3JEpo","correctMessage":"trainig-status_correctMessage__kQvWd"};